import { addStyles } from 'ethcss'
import { color, IStyles } from '../../../theme'

const screenAndSleepModeStyles: IStyles = {
    content: {
        width: '100%',
    },
    setting: {
        marginBottom: 28,
    },
    switchWrapper: {
        display: 'flex',
        marginBottom: 8,
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,
    },
    hint: {
        color: color.fontDarkMedium,
        marginTop: 8,
        lineHeight: 1.3,
    },
    field: {
        marginTop: 16,
        width: '100%',
        maxWidth: 420,
    },
}

addStyles(screenAndSleepModeStyles)
export default screenAndSleepModeStyles
